import { makeStyles, styled } from '@material-ui/core/styles';

const DrawerWidth = 980;

export const useStyles = makeStyles(theme => ({
  drawerLarge: {
    width: DrawerWidth,
    overflowY: 'hidden',
    [theme.breakpoints.down(1024)]: {
      width: '80%'
    }
  },
  drawerContentContainer: {
    padding: 0,
    backgroundColor: theme.palette.grey[50]
  },
  drawerSection: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(1)
  }
}));

export const LoaderContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%'
});
